import { render, staticRenderFns } from "./WidgetType_Table.vue?vue&type=template&id=922c0ba0"
import script from "./WidgetType_Table.vue?vue&type=script&lang=js"
export * from "./WidgetType_Table.vue?vue&type=script&lang=js"
import style0 from "./WidgetType_Table.vue?vue&type=style&index=0&id=922c0ba0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports